import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .col {
        &.col-categories {
            width: 25%;
        }
        /* &.col-categories-mobile {
            display: none;
        } */
        &.col-content {
            width: 75%;

            .accordion-list {
                .is-empty {
                    text-align: center;
                }
            }

            .questions-category {
                font-size: 2em;
                font-weight: 700;
                margin-bottom: .5em;
            }
        }
    }

    @media all and (max-width: ${variables.tabletL}) {
        flex-direction: column;

        .col {
            &.col-categories {
                width: 100%;
            }
            &.col-content {
                width: 100%;
            }
        }
    }
`;